export default __webpack_public_path__ + "static/media/director2.4b260111.jpg";